(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('RingphoneOfficeService', [
        '$http', 
        RingphoneOfficeServiceFn
    ]);
    
    function RingphoneOfficeServiceFn($http) {

        var baseUrl = '/api/ringphoneoffices/';
        var service = {
            getRingphoneOffices,
            createRingphoneOffice,
            updateRingphoneOffice,
            deleteRingphoneOffice
        };

        return service;

        function getRingphoneOffices() {
             return $http.get(`${baseUrl}`)
                         .then(function (response) {
                return response.data;
            });
        }

        function createRingphoneOffice(office) {
            return $http.post(`${baseUrl}`, office)
                        .then(function (response) {
                return response.data;
            });
        }

        function updateRingphoneOffice(id, office) {
            return $http.put(`${baseUrl}${id}`, office)
                        .then(function (response) {
                return response.data;
            });
        }

        function deleteRingphoneOffice(id) {
            return $http.delete(`${baseUrl}${id}`)
                        .then(function (response) {
                return response.data;
            });
        }
    } 
})();